module.exports = __webpack_public_path__ + "static/media/Festival.b36e9198.jpg";